import { Box, Button, Stack, Typography } from '@mui/material';
import { colors } from 'styles/theme/colors';
import Image from 'next/image';
import { useServerTranslation } from 'hooks/useServerTranslation';

type LevelThreeBackButtonProps = {
    onClick: () => void;
};

export function LevelThreeBackButton({ onClick }: LevelThreeBackButtonProps) {
    const { t } = useServerTranslation();

    return (
        <Box sx={{
            borderRight: `1px solid ${colors.gray1}`,
            paddingY: 4,
            paddingLeft: 6,
            minWidth: 200,
            width: 200,
        }}
        >
            <Button
                onClick={onClick}
                sx={{
                    color: colors.black,
                    '&:hover': { backgroundColor: 'transparent', color: colors.pink2 },
                }}
            >
                <Stack sx={{ rowGap: 2 }}>
                    <Image
                        src="/ArrowLeft.png"
                        width={40}
                        height={16}
                        alt={t('navigation.back')}
                    />
                    <Typography
                        fontWeight={500}
                        fontSize={16}
                        variant="body1"
                        textAlign="center"
                    >
                        {t('navigation.back')}
                    </Typography>
                </Stack>
            </Button>
        </Box>
    );
}
